import { X } from "lucide-solid";
import { createSignal, onCleanup, onMount, Show } from "solid-js";
import { Portal } from "solid-js/web";
import ArrowTipIcon from "~/Icons/Icon_ArrowTip.svg?component-solid";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import { Button, isUserFromRussia, sessionCounter } from "~/solidJs/shared";

const [getIsOpen, setIsOpen] = createSignal(false);
let timeout: NodeJS.Timeout;
const gptHintShownKey = "gptHintShownKey";
const getIsGptWasOpen = () => !!localStorage.getItem(gptHintShownKey);
const setIsGptWasOpen = (val: string) => localStorage.setItem(gptHintShownKey, val);
export const startShowGptPopOverCountDown = () => {
	if (sessionCounter.getCurSessionCount() > 1 || getIsGptWasOpen()) return;
	setIsGptWasOpen("true");
	timeout = setTimeout(() => setIsOpen(true), 15000);
};
export const closeGptPopOver = () => {
	clearTimeout(timeout);
	setIsOpen(false);
};
const AnalitycTracker = () => {
	onMount(() => EventAnalytics.gptEvents.popoverShown());
	onCleanup(() => EventAnalytics.gptEvents.popoverClosed());
	return null;
};
export const ChatGptPopOver = () => {
	const getHeaderText = () => {
		if (isUserFromRussia(getUserStore())) {
			return "Не знаешь, с чего начать?\nПросто напиши ассистенту";
		}
		return "Need help? Ask our\nAI Assistant";
	};
	const getPTextText = () => {
		if (isUserFromRussia(getUserStore())) {
			return "Поможет разобраться, предложит идеи\nи соберёт генерацию вместе с тобой";
		}
		return "Use any language, he can help you write prompts,\nexplain tools, give ideas, and show how to\nconnect blocks.";
	};
	return (
		<Show when={getIsOpen()}>
			<Portal>
				<AnalitycTracker />
				<div class="absolute right-2 bottom-20 z-10">
					<div class="z-10 flex h-max rounded-2xl bg-interaction-violet pt-3 pr-3 pb-5 pl-5 text-interaction-white outline-none">
						<div class="flex flex-col gap-2 pt-1">
							<h1 class="header-18-semibold whitespace-pre-wrap">
								{getHeaderText()}
							</h1>
							<div class="flex flex-col gap-4">
								<div class="whitespace-pre-wrap break-keep text-[11px] leading-[16px]">
									{getPTextText()}
								</div>
							</div>
						</div>
						<Button
							onClick={() => {
								EventAnalytics.bookDemoEvents.popOverCloseBtnClick();
								setIsOpen(false);
							}}
							class="h-max"
							variant="OverlayIcon"
						>
							<X size={16} />
						</Button>
					</div>
					<div class="arrow-tip-md relative">
						<ArrowTipIcon
							height={10}
							width={20}
							class="absolute right-10 rotate-180 text-interaction-violet"
						/>
					</div>
				</div>
			</Portal>
		</Show>
	);
};
